import { useCallback } from "react";


const useGetIntialDate = () => {


    const todayDate = new Date();
    const formatDate = todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate();
    const formatMonth = todayDate.getMonth() < 10 ? `0${todayDate.getMonth() + 1}` : todayDate.getMonth() + 1;
    const fromFormattedDate = [todayDate.getFullYear(), formatMonth, (Number(formatDate) - 1).toString()].join('-');
    const toFormattedDate = todayDate.getFullYear() + '-' + ('0' + (todayDate.getMonth() + 1)).slice(-2) + '-' + ('0' + todayDate.getDate()).slice(-2);


    //const toFormattedDate = [todayDate.getFullYear(), formatMonth, formatDate].join('-');


    //date from to yy-mm-dd:T:00:00:00 from -to 
    const formatDateForPaymentGatewayApi = useCallback((date: Date) => {
        const formatDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const formatMonthBefore = date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth();


        var oneMonthDateTimeBefore : any ;
        if (formatMonthBefore === '00') {
            oneMonthDateTimeBefore = [date.getFullYear() - 1, "12", formatDate.toString()].join('-') + "T00:00:00";
        }
        else {
            oneMonthDateTimeBefore = [date.getFullYear(), formatMonthBefore, formatDate.toString()].join('-') + "T00:00:00";
        }


        const todayDateTime = todayDate.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + "T23:59:59";
        return { oneMonthDateTimeBefore, todayDateTime }
    }, [toFormattedDate])

    //convert yy-mm-dd:T:00:00:00 
    const HandleformatDate = (date: Date, type: number) => {
        const formatDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        const formatMonth = date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const fromFormattedDate = [date.getFullYear(), formatMonth, (Number(formatDate) - 1).toString()].join('-');
        if (type === 0) {
            const todayFormattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + "T00:00:00";
            return todayFormattedDate;
        }
        else {
            const todayFormattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + "T23:59:59";
            return todayFormattedDate;
        }


    }

    const getIntialDate = () => {
        const dateControl = document.querySelectorAll('input[type="date"]');
        (dateControl[0] as HTMLInputElement).value = toFormattedDate;
        (dateControl[1] as HTMLInputElement).value = toFormattedDate;
    }

    /* const [fromDate, setFormDate] = useState('');
    const [toDate, setToDate] = useState('');
    const getIntialDate = () => {
        const todayDate = new Date();
        const dateControl = document.querySelectorAll('input[type="date"]');
        const formatDate = todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate();
        const formatMonth = todayDate.getMonth() < 10 ? `0${todayDate.getMonth() + 1}` : todayDate.getMonth() + 1;
        const fromFormattedDate = [todayDate.getFullYear(), formatMonth, (Number(formatDate) - 1).toString()].join('-');
        const toFormattedDate = [todayDate.getFullYear(), formatMonth, formatDate].join('-');
        setFormDate(fromFormattedDate);
        setToDate(toFormattedDate);
        (dateControl[0] as HTMLInputElement).value = fromFormattedDate;
        (dateControl[1] as HTMLInputElement).value = toFormattedDate;
        /* for (let i = 0; i < dateControl.length; i++) {
            (dateControl[0]as HTMLInputElement).value = fromFormattedDate;
            (dateControl[0]as HTMLInputElement).value = fromFormattedDate;
        } 
    }
     */
    const dateLocal = (datetime: any) => {
        //const dateTimeArr = datetime.split(' ');
        /* const timeArray = (dateTimeArr[1].split(":"));
        const hours = Number(timeArray[0]) + 3;
        timeArray[0] = hours;
    
        const finalTime = timeArray.join(":")
        return { date: dateTimeArr[0], time: finalTime } */
        const date = new Date(datetime);
        //console .log(date.getTime());
        //console.log("Before" + date) ; 
        date.setHours(date.getHours() + 3)
        //console.log("After "+date)
        return { date: date.toLocaleDateString(), time: date.toLocaleTimeString() };
    }

    const convertTimeStamepToDate = (dateTime: Date) => {
        const dateTimeFormat = new Date(dateTime);
        /*
        const day = dateFormat.getDate() < 10 ? `0${dateFormat.getDate()}` : dateFormat.getDate();
        const month = (dateFormat.getMonth() + 1 < 10 ? `0${dateFormat.getMonth() + 1}` : dateFormat.getMonth() + 1);
        const year = dateFormat.getFullYear();
        const hours = (dateFormat.getHours()-3) < 10 ? `0${dateFormat.getHours()-3}` : dateFormat.getHours()-3;
        const minutes = (dateFormat.getMinutes() < 10) ? `0${dateFormat.getMinutes()}` : dateFormat.getMinutes();
        const seconds = dateFormat.getSeconds() < 10 ? `0${dateFormat.getSeconds()}` : dateFormat.getSeconds();

        const dateTimeFormat = day + "/" + month + "/" + year + "-" + hours + ":" + minutes + ":" + seconds
 */
        return dateTimeFormat.toISOString().substring(0, 19);


    }


    const FormatedhDate = (dateFormat: Date|any) => {

        //console.log("mon"+dateFormat.getMonth())
        const day = dateFormat.getDate() < 10 ? `0${dateFormat.getDate()}` : dateFormat.getDate();
        const month = (dateFormat.getMonth() + 1 < 10 ? `0${dateFormat.getMonth() + 1}` : dateFormat.getMonth() + 1);
        const year = dateFormat.getFullYear();
        const dateAfterFormat = year + "-" + month + "-" + day
        return dateAfterFormat;

    }

    const handleFormateDate = (date: Date) => {
        /* console.log(date); */
        //2028-12-10 result 
        var year = date.getFullYear();
        var month: any = date.getMonth() + 1;
        var day: any = date.getDate();
        if (day < 10) {
            day = `0${day}`;
        }
        if (month < 10) {
            month = `0${month}`;
        }

        var formatedDate = `${year}-${month}-${day}`;

        return formatedDate;

    }

    function formatDateForTable(timestamp: string | number | Date) {
        const date = new Date(timestamp);
        const options: Intl.DateTimeFormatOptions = {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,     
          timeZone: "UTC",  
        };
        return date.toLocaleString("en-US", options);
      }

    const getAllDaysInMonth = (year: any, month: any): number[] | any => {
        const date = new Date(year, month);
        const dates = [];
        while (date.getMonth() === month) {
            const fulldate = new Date(date);
            dates.push(fulldate.getDate());
            date.setDate(date.getDate() + 1);
        }
        return dates;
    }



    const LastDaysCalc = (num: number) => {
        const dataLabel = [...Array(num)].map((_, i) => {
            const d = new Date()
            d.setDate(d.getDate() - i)
            const lastDays = `${d.getDate()}`
            return lastDays
        })
        //console.log(dataLabel)
        return dataLabel.reverse()
        //setLabels(dataLabel.reverse())
    }



    return { getIntialDate, fromFormattedDate, toFormattedDate, formatDateForPaymentGatewayApi, HandleformatDate, dateLocal, convertTimeStamepToDate, FormatedhDate, handleFormateDate, formatDateForTable, getAllDaysInMonth, LastDaysCalc };
}

export default useGetIntialDate; 